<template>
    <div>
        <form-header title="Anmeldung"
            subtitle="als Solistin/Solist zum"
            :tag="this.formdata.wettbewerb.name">
        </form-header>
        <ValidationObserver ref="form" v-if="this.formdata.wettbewerb.anmeldungOffen">
            <div class="bg-primary">
                <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    <transition name="fade">
                        <div class="
                                mt-0
                                mb-4
                                bg-red-100
                                border-2 border-red-200
                                px-4
                                py-4
                                sm:rounded-lg sm:p-4
                            " v-show="formbehaviour.alertrequired">
                            <div class="md:grid md:grid-cols-1 md:gap-3">
                                <div class="md:col-span-1">
                                    <h3 class="leading-3">
                                        Bitte überprüfen Sie Ihre Eingabe!
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <form-section title="Teilnehmer:in"
                        :subtitle="'Grunddaten der Teilnehmer:in<br/>' + (getAge(wettbewerbsantritt.solist.geburtsdatum) >= 1 && getAge(wettbewerbsantritt.solist.geburtsdatum) < 99 && wettbewerbsantritt.solist.geburtsdatum.length > 5 ? 'Altersgruppe: ' + getAltersgruppe(wettbewerbsantritt.solist.geburtsdatum).name : '')">
                        <text-input label="Vorname" v-model="wettbewerbsantritt.solist.vorname" rules="required" columns="2">
                        </text-input>
                        <text-input label="Nachname" v-model="wettbewerbsantritt.solist.nachname" rules="required"
                            columns="2">
                        </text-input>
                        <text-input label="Geburtsdatum" v-model="wettbewerbsantritt.solist.geburtsdatum"
                            rules="required|date" columns="2">
                        </text-input>
                        <text-input label="Straße/HNr." v-model="wettbewerbsantritt.solist.strasse" rules="required"
                            columns="6">
                        </text-input>
                        <text-input label="PLZ" v-model="wettbewerbsantritt.solist.plz" rules="required" columns="3">
                        </text-input>
                        <text-input label="Ort" v-model="wettbewerbsantritt.solist.ort" rules="required" columns="3">
                        </text-input>
                        <drop-down :values="[
                            { id: 865250000, name: 'weiblich' },
                            { id: 865250001, name: 'männlich' },
                            { id: 865250002, name: 'divers' },
                        ]" v-model="wettbewerbsantritt.solist.geschlecht" label="Geschlecht" rules="required" columns="2">
                        </drop-down>

                        <text-input label="E-Mail" v-model="wettbewerbsantritt.solist.email" rules="required|email"
                            columns="2">
                        </text-input>
                        <text-input label="Telefon" v-model="wettbewerbsantritt.solist.telefonnummer" rules="required"
                            placeholder="0664 111 22 33" columns="2"></text-input>
                        
                        <drop-down
                                :values="formdata.instrumente"
                                label="Instrument"
                                v-model="wettbewerbsantritt.solist.instrumentId"
                                rules="required"
                                columns="3"
                            />

                        <drop-down label="Musikschule" :rules="wettbewerbsantritt.solist.andereInstitution ? '' : 'required'"
                            :values="formdata.musikschulen" v-model="wettbewerbsantritt.solist.musikschuleId"></drop-down>

                        <text-input label="oder andere Institution/Privat"
                            :rules="wettbewerbsantritt.solist.musikschuleId ? '' : 'required'"
                            v-model="wettbewerbsantritt.solist.andereInstitution"></text-input>
                            
                    </form-section>

                    <!-- Lehrperson -->
                    <form-section title="Lehrperson" subtitle="Grunddaten der Lehrperson">
                        <text-input label="Titel voran." v-model="wettbewerbsantritt.lehrperson.titelVor" columns="1"></text-input>

                        <text-input label="Vorname" v-model="wettbewerbsantritt.lehrperson.vorname" rules="required" columns="2">
                        </text-input>
                        <text-input label="Nachname" v-model="wettbewerbsantritt.lehrperson.nachname" rules="required"
                            columns="2">
                        </text-input>
                        <text-input label="Titel nach." v-model="wettbewerbsantritt.lehrperson.titelNach" columns="1"></text-input>
                        <drop-down :values="[
                            { id: 865250000, name: 'weiblich' },
                            { id: 865250001, name: 'männlich' },
                            { id: 865250002, name: 'divers' },
                        ]" v-model="wettbewerbsantritt.lehrperson.geschlecht" label="Geschlecht" rules="required" columns="2">
                        </drop-down>

                        <text-input label="E-Mail" v-model="wettbewerbsantritt.lehrperson.email" rules="required|email"
                            columns="2">
                        </text-input>
                        <text-input label="Telefon" v-model="wettbewerbsantritt.lehrperson.telefonnummer" rules="required"
                            placeholder="0664 111 22 33" columns="2"></text-input>

                        <drop-down label="Musikschule" :rules="wettbewerbsantritt.lehrperson.andereInstitution ? '' : 'required'"
                            :values="formdata.musikschulen" v-model="wettbewerbsantritt.lehrperson.musikschuleId"></drop-down>

                        <text-input label="oder andere Institution/Privat"
                            :rules="wettbewerbsantritt.lehrperson.musikschuleId ? '' : 'required'"
                            v-model="wettbewerbsantritt.lehrperson.andereInstitution"></text-input>
                    </form-section>

                    <!-- 1. Begleitung -->
                    <div v-if="false" class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                        <div class="md:grid md:grid-cols-3 md:gap-6">
                            <div class="md:col-span-1">
                                <h3 class="text-lg font-medium leading-6 text-gray-900">Instrumentalbegleitung</h3>
                                <button @click="begleitung1enabled = true" type="button" class="
                                                w-20
                                                py-1
                                                text-base
                                                font-medium
                                                rounded-l-md
                                                text-white
                                                text-center
                                                hover:opacity-75
                                                mt-2
                                            " :class="[begleitung1enabled ? 'bg-green-600' : 'bg-gray-400']">
                                    Ja
                                </button>
                                <button @click="begleitung1enabled = false" type="button" class="
                                                items-center
                                                py-1
                                                w-20
                                                text-base
                                                font-medium
                                                rounded-r-md
                                                text-white
                                                text-center
                                                hover:opacity-75
                                            " :class="[!begleitung1enabled ? 'bg-green-600' : 'bg-gray-400']">
                                    Nein
                                </button>
                            </div>
                            <div class="mt-5 md:mt-0 md:col-span-2">
                                <div class="grid grid-cols-6 gap-6 items-end" v-if="begleitung1enabled">
                                   
                                    <drop-down
                                :values="formdata.instrumentebegleitung"
                                label="Instrument"
                                rules="required"
                                v-model="wettbewerbsantritt.begleitung.instrumentId"
                                columns="3"
                            />
                                  
                                    <span class="col-span-3"></span>
                                    <text-input label="Vorname" v-model="wettbewerbsantritt.begleitung.vorname"
                                        rules="required" columns="2">
                                    </text-input>
                                    <text-input label="Nachname" v-model="wettbewerbsantritt.begleitung.nachname"
                                        rules="required" columns="2">
                                    </text-input>
                                    <text-input label="Geburtsdatum" v-model="wettbewerbsantritt.begleitung.geburtsdatum"
                                        rules="required|date" columns="2">
                                    </text-input>
                                    <text-input label="Straße" v-model="wettbewerbsantritt.begleitung.strasse"
                                        rules="required" columns="6">
                                    </text-input>
                                    <text-input label="PLZ" v-model="wettbewerbsantritt.begleitung.plz" rules="required"
                                        columns="3">
                                    </text-input>
                                    <text-input label="Ort" v-model="wettbewerbsantritt.begleitung.ort" rules="required"
                                        columns="3">
                                    </text-input>
                                    <drop-down :values="[
                                        { id: 865250000, name: 'weiblich' },
                            { id: 865250001, name: 'männlich' },
                            { id: 865250002, name: 'divers' },
                                    ]" v-model="wettbewerbsantritt.begleitung.geschlecht" label="Geschlecht"
                                        rules="required" columns="2">
                                    </drop-down>

                                    <text-input label="E-Mail" v-model="wettbewerbsantritt.begleitung.email"
                                        rules="required|email" columns="2">
                                    </text-input>
                                    <text-input label="Telefon" v-model="wettbewerbsantritt.begleitung.telefonnummer"
                                        rules="required" placeholder="0664 111 22 33" columns="2"></text-input>
                                    <drop-down label="Musikschule"
                                        :rules="wettbewerbsantritt.begleitung.andereInstitution ? '' : 'required'"
                                        :values="formdata.musikschulen"
                                        v-model="wettbewerbsantritt.begleitung.musikschuleId"></drop-down>
                                    <text-input label="oder andere Institution/Privat"
                                        :rules="wettbewerbsantritt.begleitung.musikschuleId ? '' : 'required'"
                                        v-model="wettbewerbsantritt.begleitung.andereInstitution"></text-input>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 border-2"
                        :class="[musikstueckeValid() == '' ? 'border-green-300' : 'border-red-300']"
                        v-if="altersgruppe()">
                        In der Altersgruppe <strong>{{ altersgruppe().name }}</strong> sind {{ altersgruppe().pflichtstuecke }}
                        Musikstücke notwendig.<br /><strong>{{ musikstueckeValid()
}}</strong>
                    </div>
                    <div class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 border-2 border-red-300"
                        v-if="playbackvalid() == false">
                        Es darf nur ein Stück mit Playback/Playalong gespielt werden!
                    </div>
                    <div class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
                        v-for="(stueck, index) in wettbewerbsantritt.musikstuecke" :key="index">
                        <div class="md:grid md:grid-cols-3 md:gap-6">
                            <div class="md:col-span-1">
                                <h3 class="text-lg font-medium leading-6 text-gray-900">{{ stueck.reihenfolge + '.Stück'
                                }}</h3>
                                <p class="mt-1 text-sm leading-5 text-gray-500">Wettbewerbsprogramm</p>
                                <button @click="removeMusikStueck(index)" type="button" class="
                                                items-center
                                                mt-2
                                                w-32
                                                text-base
                                                font-medium
                                                rounded-md
                                                text-white
                                                text-center
                                                hover:opacity-75
                                                bg-gray-600
                                                mx-auto
                                            ">
                                    Entfernen
                                </button>
                            </div>
                            <div class="mt-5 md:mt-0 md:col-span-2">
                                    <div class="grid grid-cols-6 gap-6">
                                        <text-input v-model="stueck.titel" label="Titel" columns="4"
                                            rules="required"></text-input>
                                        <text-input v-model="stueck.dauer" label="Dauer" columns="2"
                                            rules="required"></text-input>
                                        <text-input v-model="stueck.komponist" label="Komponist" columns="3"></text-input>
                                        <drop-down :values="[
                                             { name: 'Alpenländische Volksmusik', id: 865250005 },
                                        { name: 'Volksmusik aus den östlichen Bundesländern Österreichs', id: 865250004 },
                                        { name: 'Europäische Volksmusik', id: 865250006 },
                                        { name: 'Zeitgenössische Volksmusik', id: 865250007 },
                                        ]" v-model="stueck.kategorie" label="Kategorie" rules="required"
                                            columns="3"></drop-down>
                                    </div>
                            </div>
                            <div v-if="false" class="mt-5 md:mt-0 md:col-span-2">
                                <div class="grid grid-cols-6 gap-6 items-end">
                                    <text-input label="Interpret" v-model="stueck.interpret" columns="3"
                                        rules="required"></text-input>
                                    <text-input label="Titel/Bezeichnung" v-model="stueck.titel" columns="3"
                                        rules="required">
                                    </text-input>
                                    <text-input label="Dauer (mm:ss)" v-model="stueck.dauer" rules="required"
                                        columns="3"></text-input>
                                    <drop-down label="Stilkategorie" rules="required" :values="[
                                        { name: 'Alpenländische Volksmusik', id: 865250005 },
                                        { name: 'Volksmusik aus den östlichen Bundesländern Österreichs', id: 865250004 },
                                        { name: 'Europäische Volksmusik', id: 865250006 },
                                        { name: 'Zeitgenössische Volksmusik', id: 865250007 },
                                    ]" v-model="stueck.kategorie" columns="3"></drop-down>
                                    <!--<drop-down label="Begleitung" rules="required" :values="[
                                        { name: 'Unbegleitet', id: 865250000 },
                                        { name: 'Instrumentalbegleitung', id: 865250001 },
                                        { name: 'Playback/Playalong', id: 865250002 },
                                    ]" v-model="stueck.begleitung" columns="3"></drop-down>-->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mb-6 pb-5 flex" v-if="wettbewerbsantritt.musikstuecke.length < 5">
                        <button @click="wettbewerbsantritt.musikstuecke.push({ reihenfolge: wettbewerbsantritt.musikstuecke.length + 1 })"
                            type="button" class="
                                                items-center
                                                py-1
                                                w-56
                                                text-base
                                                font-medium
                                                rounded-md
                                                text-white
                                                text-center
                                                hover:opacity-75
                                                bg-gray-600
                                                mx-auto
                                            ">
                            + Musikstück hinzufügen
                        </button>
                    </div>
                    <form-section title="Anmerkungen" subtitle="Haben Sie sonstige Anmerkungen zu Ihrer Anmeldung?">
                            <text-area-input label="" v-model="wettbewerbsantritt.anmerkungen" columns="6"
                                rows="5"></text-area-input>
                        </form-section>

                    <form-section title="Informationspflicht" subtitle="gem. Art. 13 DSGVO">
                        <text-block class="col-span-6" :content="
                            textbausteinfuer(
                                'allgemein.informationspflicht'
                            ).contentPlain
                        " />
                    </form-section>

<form-section title="Bild und Ton">
    <div class="col-span-6 sm:col-span-5">
        <text-block :content="textbausteinfuer(
            'zustimmung.bildundton'
        ).contentPlain
            " />
    </div>
</form-section>
                   
                    <div class="
                            mt-6
                            bg-white
                            shadow
                            px-4
                            py-5
                            sm:rounded-lg sm:p-6
                        ">
                        <div class="md:grid md:grid-cols-3 md:gap-6">
                            <div class="md:col-span-1">&nbsp;</div>
                            <div class="grid grid-cols-6 gap-6">
                                <div class="col-span-6">
                                    <span class="inline-flex rounded-md shadow-sm">
                                        <button @click="sendAnsuchen()" type="button" class="
                                                inline-flex
                                                items-center
                                                px-48
                                                sm:px-8
                                                py-2
                                                border border-transparent
                                                text-base
                                                leading-6
                                                font-medium
                                                rounded-md
                                                text-white
                                                bg-green-600
                                                hover:bg-green-500
                                                focus:outline-none
                                                focus:border-indigo-700
                                                focus:shadow-outline-green
                                                active:bg-green-700
                                                transition
                                                ease-in-out
                                                duration-150
                                            ">
                                            Anmeldung abschicken
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
        <div v-else>
            <form-section>
                <div class="col-span-6 sm:col-span-5">
                    Die Anmeldung zu diesem Wettbewerb ist derzeit nicht möglich
                </div>
            </form-section>
        </div>

        <success-modal text="Sie können das Fenster nun schließen." v-if="formbehaviour.showSuccessModal">
        </success-modal>
        <sending-modal v-if="formbehaviour.showSendingModal"></sending-modal>
        <error-modal @clickedoutside="formbehaviour.showErrorModal = false" :text="formbehaviour.errorText"
            v-if="formbehaviour.showErrorModal"></error-modal>
    </div>
</template>

<script>
import FormSection from '../../components/forms/FormSection.vue'
import FormHeader from '@/components/forms/FormHeader.vue'
import DropDown from '@/components/inputs/DropDown.vue'
import TextInput from '@/components/inputs/TextInput.vue'
import TextAreaInput from '@/components/inputs/TextAreaInput.vue'
import TextBlock from '@/components/inputs/TextBlock.vue'
import CheckBox from '@/components/inputs/CheckBox.vue'
import FileUpload from '@/components/inputs/FileUpload.vue'
import SendingModal from '@/components/modals/SendingModal.vue'
import SuccessModal from '@/components/modals/SuccessModal.vue'
import ErrorModal from '@/components/modals/ErrorModal.vue'
import RadioButtonList from '@/components/inputs/RadioButtonList.vue'

export default {
    name: 'Form',
    inject: ['service'],
    props: {
        id: {
            id: String,
            required: true,
        },
    },
    data() {
        return {
            begleitung1enabled: false,
            formbehaviour: {
                alertrequired: false,
                showSendingModal: false,
                showSuccessModal: false,
                showErrorModal: false,
                errorText: '',
                openSubmitModal: false,
                successful: false,
                alertForDocumentsRequired: false,
                adresseMusikerUebernehmen: false,
            },
            formdata: {
                wettbewerb: {},
                altersgruppen: [],
                textbausteine: [],
                musikschulen: [],
                instrumente: [],
                instrumentebegleitung: [],
            },
            wettbewerbsantritt: {
                anmerkungen: null,
                wettbewerbId: null,
                altersgruppeId: null,
                kontaktEmail: null,
                solist: {
                    vorname: null,
                    nachname: null,
                    geburtsdatum: null,
                    geschlecht: null,
                    strasse: null,
                    ort: null,
                    plz: null,
                    telefonnummer: null,
                    email: null,
                    musikschuleId: null,
                    andereInstitution: null,
                    instrumentId: null,
                },
                lehrperson: {
                    titelVor: null,
                    titelNach: null,
                    vorname: null,
                    nachname: null,
                    geschlecht: null,
                    telefonnummer: null,
                    email: null,
                    musikschuleId: null,
                    andereInstitution: null
                },
                begleitung: {
                    vorname: null,
                    nachname: null,
                    geburtsdatum: null,
                    geschlecht: null,
                    strasse: null,
                    ort: null,
                    plz: null,
                    telefonnummer: null,
                    email: null,
                    instrumentId: null,
                    musikschuleId: null,
                    andereInstitution: null
                },
                musikstuecke: [
                    {
                        reihenfolge: 1,
                        komponist: null,
                        interpret: null,
                        titel: null,
                        dauer: null,
                        kategorie: null,
                        begleitung: null,
                    },
                    {
                        reihenfolge: 2,
                        komponist: null,
                        interpret: null,
                        titel: null,
                        dauer: null,
                        kategorie: null,
                        begleitung: null,
                    },
                ]
            },
        }
    },
    methods: {
        async fetchWettbewerb() {
           const { data } = await this.service.wettbewerb.get(this.id).info()
           this.formdata.wettbewerb = data
        },
        async fetchAltersgruppen() {
           const { data } = await this.service.wettbewerb.get(this.id).altersgruppen(1);
           this.formdata.altersgruppen = data
        },
        async fetchMusikschulen() {
           
            const { data } = await this.service.musikschule.powerAppsAlle()

            this.formdata.musikschulen = data
            this.formdata.musikschulen.sort((a, b) =>
                a.kurzbezeichnung > b.kurzbezeichnung ? 1 : -1
            )
        },
        async fetchTextbausteine() {
            const { data } = await this.service.formular
                .get('volksmusik')
                .textbloeckePowerApps()
            this.formdata.textbausteine = data
        },
        async fetchFaecher() {
            const { data } = await this.service.wettbewerb.get(this.id).faecher();
            this.formdata.instrumente = data
        },
        async fetchFaecherBegleitung() {
            const { data } = await this.service.fach.pruefungsordnung()
            this.formdata.instrumentebegleitung = data
        },
        async sendAnsuchen() {
            var validation = await this.$refs.form.validate();

            if (!validation || this.musikstueckeValid() != '' || !this.playbackvalid()) {
                window.scrollTo(0, 0);
                this.formbehaviour.alertrequired = true;
                return;
            }

            try {
                if (!this.begleitung1enabled)
                    this.wettbewerbsantritt.begleitung = null;

                this.wettbewerbsantritt.wettbewerbId = this.formdata.wettbewerb.id;
                this.wettbewerbsantritt.altersgruppeId =  this.altersgruppe().id;
                this.wettbewerbsantritt.kontaktEmail = this.wettbewerbsantritt.solist.email;

                this.formbehaviour.showSendingModal = true;
                await this.service.wettbewerb.senden(this.wettbewerbsantritt);
                this.formbehaviour.showSendingModal = false;
                this.formbehaviour.showSuccessModal = true;
            } catch (e) {
                this.formbehaviour.showSendingModal = false;
                this.formbehaviour.showErrorModal = true;
                this.formbehaviour.errorText = "Es ist ein Fehler bei der Übertragung aufgetreten."
            }
        },
        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                (element) => element.identifier == id
            )
            if (!found) return id

            return found
        },
        getAge(dateString) {
            if (!dateString)
                return null;

            var pattern = /(\d{1,2})\.(\d{1,2})\.(\d{4})/;
            var birthDate = new Date(dateString.replace(pattern, '$3-$2-$1'));

            var today = new Date(this.formdata.wettbewerb.stichtag);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        },

        altersgruppe() {
            if (this.wettbewerbsantritt.solist.geburtsdatum == null)
                return null;

            var gruppe = this.getAltersgruppe(this.wettbewerbsantritt.solist.geburtsdatum);

            if (gruppe)
                this.wettbewerbsantritt.altersgruppeId = gruppe.id;

            return gruppe;
        },

        musikstueckeValid() {
           var altersgruppe = this.altersgruppe();

            if (altersgruppe == null)
                return 'Keine Altersgruppe gefunden.';

            if (altersgruppe.pflichtstuecke > this.wettbewerbsantritt.musikstuecke.length)
                return 'Momentan sind zu wenige Musikstücke angegeben.';

            var gesamtdauer = 0;
            var pflichtkategorie = false;
            var kategorien = [];

            this.wettbewerbsantritt.musikstuecke.forEach(stueck => {
                if (stueck.dauer != null && stueck.dauer.indexOf(':') > -1)
                    stueck.dauerInMinuten = ((Number(stueck.dauer.split(':')[0]) * 60) + Number(stueck.dauer.split(':')[1])) / 60.0;
                else
                    stueck.dauerInMinuten = 0;
                gesamtdauer += stueck.dauerInMinuten;

                pflichtkategorie = pflichtkategorie || stueck.kategorie == 865250005;
                if(!kategorien.includes(stueck.kategorie) && stueck.kategorie){
                    kategorien.push(stueck.kategorie);
                }
            });

            //if (altersgruppe.spielzeitMin > gesamtdauer)
            //    return 'Die Gesamtdauer der Musikstücke ist zu kurz.';

            //if (altersgruppe.spielzeitMax < gesamtdauer)
            //    return 'Die Gesamtdauer der Musikstücke ist zu lang.';

            if (!pflichtkategorie || kategorien.length < 2)
                return 'Mind. zwei verschiedene Kategorien sind abzudecken, mind. ein Stück aus der Kategorie "Alpenländische Volksmusik"';

            if(this.id.toLowerCase() == 'drumset2025'){
                var unbegleitetLimit = false;

                if(!this.wettbewerbsantritt.musikstuecke.find(stueck => stueck.begleitung == 865250000)){
                    return "Es fehlt ein unbegleitetes Solo."
                }

                this.wettbewerbsantritt.musikstuecke.forEach(stueck => {
                    if(stueck.begleitung != 865250000)
                        return;

                    if(altersgruppe.alterVon == 17 && this.getDauerInMinuten(stueck) >= 2)
                        unbegleitetLimit = true;

                    if((altersgruppe.alterVon == 10 || altersgruppe.alterVon == 12 || altersgruppe.alterVon == 14) && this.getDauerInMinuten(stueck) >= 1.5)
                        unbegleitetLimit = true;

                    if((altersgruppe.alterVon == 0 || altersgruppe.alterVon == 8) && this.getDauerInMinuten(stueck) >= 1)
                        unbegleitetLimit = true;
                
                });

                if(!unbegleitetLimit){
                    return 'Das unbegleitete Solo ist zu kurz.'
                }
            }

            return '';
        },

        getDauerInMinuten(stueck){
            return ((Number(stueck.dauer.split(':')[0]) * 60) + Number(stueck.dauer.split(':')[1])) / 60.0;
        },

        playbackvalid() {
            return this.wettbewerbsantritt.musikstuecke.filter((ms) => ms.playback == true).length < 2;
        },

        getAltersgruppe(dateString) {
            if (!dateString)
                return;

            var age = this.getAge(dateString);
            
            var altersgruppe = this.formdata.altersgruppen.find(ag => ag.alterVon <= age && ag.maximalalter >= age);

            if(altersgruppe){
                return altersgruppe;
            }

            return {
                name: 'n/a',
                id: null
            }
        },

        removeMusikStueck(index) {
            this.wettbewerbsantritt.musikstuecke.splice(index, 1);
            var i = 1;
            this.wettbewerbsantritt.musikstuecke.forEach(
                item => item.reihenfolge = i++
            );
        }
    },

    components: {
        FormSection,
        FormHeader,
        TextInput,
        DropDown,
        CheckBox,
        TextBlock,
        FileUpload,
        SendingModal,
        SuccessModal,
        ErrorModal,
        TextAreaInput,
        RadioButtonList,
    },
    async created() {
        try {
            this.fetchWettbewerb()
            this.fetchAltersgruppen()
            this.fetchMusikschulen()
            this.fetchTextbausteine()
            this.fetchFaecher()
            this.fetchFaecherBegleitung()
            this.formbehaviour.errorText = ''
            this.formbehaviour.showErrorModal = false
        } catch {
            this.formbehaviour.errorText =
                'Die Information für die Anmeldung konnte nicht geladen werden.'
            this.formbehaviour.showErrorModal = true;
        }
    },
}
</script>

<style>

</style>